import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const Url='/bookcategory';
const backUrl='/library'+Url;
 
class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            name:'', 
            access_key:'',
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){
        if(this.props.match.params.id){
            viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                if(res.data.status===200){
                    let data=res.data.data;
                    this.setState({
                        name:data.name?data.name:'', 
                        access_key:data.access_key?data.access_key:'', 
                        preloader:false, 
                    });
                }
            });
        }
    }
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        obj[event.target.access_key] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let params={
                name:this.state.name,
                access_key:this.state.access_key
            };
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.msg?res.data.msg:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
 
  
    render() {
        let {title,preloader} = this.state;
        let role=permissionCheck('bookcategory',title);
        if(!role)
            return <Nopermission/>;
        const nameValid= this.validator.message('name', this.state.name, 'required');
        const access_keyValid= this.validator.message('access_key', this.state.name, 'required');
        return (
            <div id="page_content_inner" className="uk-width-medium-4-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{title} Book Category</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${this.state.name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Book Category<span className="req">*</span></label>
                                    <input type="text" name="name" value={this.state.name} onChange={this.setStateFromInput} className={ `md-input ${nameValid ?'md-input-danger':''}`} /> 
                                    {nameValid} 
                                </div>
                            </div>
                        </div>

                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${this.state.access_key ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Access Key<span className="req">*</span></label>

                                    {
                                        this.props.match.params.id ?<input type="text" name="access_key" value={this.state.access_key}  className={ `md-input ${access_keyValid ?'md-input-danger':''}`} disabled /> :<input type="text" name="access_key" value={this.state.access_key} onChange={this.setStateFromInput} className={ `md-input ${access_keyValid ?'md-input-danger':''}`} /> 
                                    } 
                                    {access_keyValid} 
                                </div>
                            </div>
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1">
                                <Link to={backUrl} className="md-btn md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Library/BookCategory/addEdit.js